"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var Icons_1 = require("atomicComponents/molecules/Icon/Icons");
var DropdownLinkOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownLinkOption"));
var single_1 = require("utils/selectors/single");
var utils_1 = require("../utils");
var DropdownGroup_1 = __importDefault(require("./DropdownGroup"));
var ConnectionsGroup = function (_a) {
    var item = _a.item;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var paymentsConnection = (0, react_redux_1.useSelector)(single_1.selectMainPaymentConnections);
    var stripeURL = (0, utils_1.makeStripeURL)(item, profile.isAdmin, paymentsConnection);
    var xeroURL = (0, utils_1.makeXeroURL)(item);
    var extLinks = [{ url: stripeURL, name: 'Stripe' }, { url: xeroURL, name: 'Xero' }].filter(function (_a) {
        var url = _a.url;
        return url;
    });
    return ((0, jsx_runtime_1.jsxs)(DropdownGroup_1.default, __assign({ categoryTitle: "Connections", hideDivider: true }, { children: [(0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { title: "View charges", to: "/recharges/charges/all?filter[customerId]=".concat(item.rechargedCustomerId) }), (0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { title: "View customer", to: "/recharges/mapping/all?filter[customerId]=".concat(item.rechargedCustomerId) }), (0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { title: "View agreement", to: "/recharges/agreements?filter[id]=".concat(item.rechargedCustomerId) }), extLinks.map(function (_a) {
                var url = _a.url, name = _a.name;
                return ((0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { href: url, title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Open invoice on ", name, " ", (0, jsx_runtime_1.jsx)(Icons_1.LinkIcon, {})] }) }, name));
            }), profile.isAdmin && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { href: (0, end2end_1.getDocUrl)('recharge_invoices', item.id), title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Open invoice in Firestore ", (0, jsx_runtime_1.jsx)(Icons_1.LinkIcon, {})] }) }), (0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { href: (0, end2end_1.getDocUrl)('recharged_customers', item.rechargedCustomerId), title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Open customer in Firestore ", (0, jsx_runtime_1.jsx)(Icons_1.LinkIcon, {})] }) })] }))] })));
};
exports.default = ConnectionsGroup;
